import { render } from "./ViewAddSourcePath.vue?vue&type=template&id=4d470d88"
import script from "./ViewAddSourcePath.vue?vue&type=script&lang=js"
export * from "./ViewAddSourcePath.vue?vue&type=script&lang=js"

import "./ViewAddSourcePath.vue?vue&type=style&index=0&id=4d470d88&lang=scss"

import exportComponent from "/app/tmp/ardia/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__